import { z } from 'zod';
export const communicationsInsuranceClaimsAdjusterCorrespondenceFactsCapability = 'communications.adjuster-correspondence-facts.v1';
export const communicationsInsuranceClaimsAdjusterCorrespondenceSlot = 'insurance-claims.adjuster-correspondence-facts';
export const communicationsInsuranceClaimsAdjusterCorrespondenceProviderId = 'communications.server.insurance-claims-adjuster-correspondence';
const idSchema = z.string().uuid();
const sha256Schema = z.string().regex(/^[a-f0-9]{64}$/);
export const communicationsInsuranceClaimsAdjusterCorrespondenceRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(communicationsInsuranceClaimsAdjusterCorrespondenceFactsCapability),
    resourceType: z.literal('insurance-claims.claim'),
    resourceId: idSchema,
    preferredSourceId: idSchema,
    projectId: idSchema,
});
export const communicationsInsuranceClaimsAdjusterCorrespondenceFactSchema = z.strictObject({
    capability: z.literal(communicationsInsuranceClaimsAdjusterCorrespondenceFactsCapability),
    threadId: idSchema,
    sourceVersion: z.number().int().positive(),
    contentHash: sha256Schema,
    projectId: idSchema,
    contactId: idSchema,
    subject: z.string().trim().max(240).nullable(),
    latestMessage: z.strictObject({
        messageId: idSchema,
        direction: z.enum(['inbound', 'outbound']),
        occurredAt: z.string().datetime({ offset: true }),
    }),
    lastOutboundAt: z.string().datetime({ offset: true }).nullable(),
    observedAt: z.string().datetime({ offset: true }),
});
export const communicationsInsuranceClaimsAdjusterCorrespondenceResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(communicationsInsuranceClaimsAdjusterCorrespondenceFactsCapability),
    projectId: idSchema,
    contactId: idSchema,
    facts: z.array(communicationsInsuranceClaimsAdjusterCorrespondenceFactSchema).max(500),
}).superRefine((value, context) => {
    const threadIds = value.facts.map(({ threadId }) => threadId);
    if (new Set(threadIds).size !== threadIds.length) {
        context.addIssue({ code: 'custom', path: ['facts'], message: 'Correspondence threads must be unique.' });
    }
    value.facts.forEach((fact, index) => {
        if (fact.projectId !== value.projectId || fact.contactId !== value.contactId) {
            context.addIssue({
                code: 'custom',
                path: ['facts', index],
                message: 'Correspondence facts must belong to the requested Project and contact.',
            });
        }
    });
});
//# sourceMappingURL=communications-insurance-claims-adjuster-correspondence.contract.js.map